import styled from 'styled-components';
import { colors } from '@/styles';

export const Dropzone = styled.div<{ $error: boolean }>`
  border: 1px solid ${(props) => (props.$error ? colors.semantic.negative.dark : colors.secondary.lightGray2)};
  background: ${colors.semantic.information.light};
  border-radius: 5px;
  width: 100%;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;

  .error {
    padding: 10px;
    color: ${colors.semantic.negative.dark};
    font-weight: bold;
  }
`;

export const DropzoneContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;
